function t(t){return function(n){var c=n.element,e=n.state,o=t;return c&&(o="".concat(o,"_").concat(c)),e&&(o="".concat(o,"--").concat(e)),o}}export{t as BEMClass};
